import styled from 'styled-components';

const getHeight = (isMobile: boolean, isPreview: boolean) => {
  if (isPreview) {
    return '82px';
  }

  if (isMobile) {
    return '74px';
  }

  return '128px';
};

export const HeaderSkeleton = styled.div<{
  $isMobile: boolean;
  $isPreview: boolean;
}>`
  height: ${({ $isMobile, $isPreview }) => getHeight($isMobile, $isPreview)};
  background: #17181a;
`;
